// Assainissement du HTML rendu via dangerouslySetInnerHTML (audit sécurité du 15/10, F2).
// Un contenu riche (réponse FAQ, aperçu d'e-mail) est rendu en HTML : sans ce filtre, un
// HTML hostile s'exécuterait dans le navigateur de la personne (vol du jeton de session).
// Liste blanche calée sur ce que produit RichTextEditor (gras, italique, listes, titres,
// liens) ; tout le reste (script, on*, iframe, style…) est retiré par DOMPurify.
import DOMPurify from "dompurify";

const CONFIG = {
  ALLOWED_TAGS: ["p", "br", "strong", "b", "em", "i", "u", "h2", "h3", "ul", "ol", "li", "a", "span"],
  ALLOWED_ATTR: ["href", "target", "rel"],
  ALLOWED_URI_REGEXP: /^(https?:|mailto:|tel:|#)/i, // pas de javascript:
};

// Un lien externe s'ouvre sans donner la main à la page cible (noopener).
DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "A" && node.getAttribute("href")) {
    node.setAttribute("target", "_blank");
    node.setAttribute("rel", "noopener noreferrer nofollow");
  }
});

export const cleanHtml = (html) => DOMPurify.sanitize(html || "", CONFIG);

// À passer directement à dangerouslySetInnerHTML : richHtml(valeur)
export const richHtml = (html) => ({ __html: cleanHtml(html) });
